module.exports = __webpack_public_path__ + "media/icons/key-4-dark-c3058baf.svg";